/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { HRISDataSource } from '../models/HRISDataSource';
import type { SaveHRISDataSourceRequest } from '../models/SaveHRISDataSourceRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class HrisDataSourceService {

    /**
     * Return HRIS Data Source list
     * @returns HRISDataSource Success
     * @throws ApiError
     */
    public static listHrisDataSources({
        dataType,
    }: {
        /**
         * Data Type
         */
        dataType?: string,
    }): CancelablePromise<Array<HRISDataSource>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/hrisDataSource',
            query: {
                'dataType': dataType,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Save hris data sources
     * @returns HRISDataSource Success
     * @throws ApiError
     */
    public static saveHrisDataSources({
        requestBody,
    }: {
        requestBody: SaveHRISDataSourceRequest,
    }): CancelablePromise<Array<HRISDataSource>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/hrisDataSource',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
